import { cloneElement, useEffect, useRef, useState } from 'react';
import styled from 'styled-components';

import { Marker } from '.';

type Props = {
  latLongArray: {
    key: string;
    lat: number;
    long: number;
  }[];

  onClick?: (key: string) => void;
};

const MapDiv = styled.div`
  height: 432px;
  min-width: 341px;
  margin-left: 4px;
  margin-right: 4px;
  flex: 1;
  border-radius: ${(props) => props.theme.borderRadius};
  overflow: hidden;

  @media ${(props) => props.theme.breakpoints.xs} {
    height: 360px;
    min-width: 250px;
  }
`;

const SimpleMap: React.FC<Props> = ({ latLongArray, onClick }) => {
  const ref = useRef<HTMLDivElement>(null);
  const mapBoundsRef = useRef<google.maps.LatLngBounds>();

  const [map, setMap] = useState<google.maps.Map>();

  useEffect(() => {
    if (ref.current && !map) {
      const auxMap = new google.maps.Map(ref.current, {
        fullscreenControl: false,
        gestureHandling: 'greedy',
        mapTypeControl: false,
        streetViewControl: false,
        zoom: 15,
      });
      setMap(auxMap);
    }
  }, [latLongArray, map]);

  useEffect(() => {
    if (map && latLongArray.length > 0) {
      const mapBounds = new google.maps.LatLngBounds();
      for (const { lat, long } of latLongArray) {
        mapBounds.extend(
          new google.maps.LatLng({
            lat,
            lng: long,
          })
        );
      }
      if (!mapBoundsRef.current?.getCenter()?.equals(mapBounds.getCenter())) {
        mapBoundsRef.current = mapBounds;
        map.fitBounds(mapBounds, latLongArray.length > 5 ? 10 : 80);
        setTimeout(() => {
          if (map.getZoom() > 15) {
            map.setZoom(15);
          }
        }, 100);
      }
    }
  }, [latLongArray, map]);

  return (
    <MapDiv>
      <div ref={ref} style={{ height: '100%' }} />
      {latLongArray.map((latLong) =>
        cloneElement(
          <Marker
            key={latLong.key}
            position={{ lat: latLong.lat, lng: latLong.long }}
            icon={{
              url: '/images/map_marker_selected.svg',
              scaledSize: new google.maps.Size(42, 42),
            }}
            zIndex={100}
            onClick={() => onClick(latLong.key)}
          />,
          { map }
        )
      )}
      {}
    </MapDiv>
  );
};

export default SimpleMap;
